// hotel list variables
export const GET_HOTELS_REQUEST = "GET_HOTELS_REQUEST";
export const GET_HOTELS_SUCCESS = "GET_HOTELS_SUCCESS";
export const GET_HOTELS_FAILED = "GET_HOTELS_FAILED";

export const STAR_RATING_FILTER = "STAR_RATING_FILTER";
